$( function() {
	var running = false;
	function getImagesProfile(append) {
		if(running) return;

		var $gal = $('ul.gallery');
		var _url = '/profil/getimages';
		var formData = {};
		formData.page = parseInt($gal.data('page')) + 1;

		$.get(_url, formData, function(res) {
			running = false;

			if(res.length) {
				if(!append) {
					$gal.empty();
				}
				$(res).hide().appendTo($gal).fadeIn();

				$gal.Chocolat({
					imageSelector: '.img-wrapper'
				});
			}
		}, 'html');
	}

	if($('.profile').find('ul.gallery').length) {
		getImagesProfile(false);
		$('.profile').find('ul.gallery').on('imagesupdate', function(e) {
			getImagesProfile(false);
		});
	}
});